import { BusinessCenterOutlined, PersonOutlineOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import {
    AudienceButton,
    AudienceIcon,
    AudienceText,
    Selector,
} from './AuthAudienceSelector.styles';

export type AuthAudienceSelectorProps = {
    onEmployerClick: () => void
};

const AuthAudienceSelector = ({ onEmployerClick }: AuthAudienceSelectorProps): JSX.Element => (
    <Selector aria-label="בחירת סוג משתמש">
        <AudienceButton $active type="button" aria-current="page">
            <AudienceIcon $active>
                <PersonOutlineOutlined />
            </AudienceIcon>
            <AudienceText>
                <Typography variant="subtitle1" fontWeight="bold">מחפש/ת עבודה</Typography>
            </AudienceText>
        </AudienceButton>
        <AudienceButton $active={false} type="button" onClick={onEmployerClick}>
            <AudienceIcon $active={false}>
                <BusinessCenterOutlined />
            </AudienceIcon>
            <AudienceText>
                <Typography variant="subtitle1" fontWeight="bold">מעסיק/ה</Typography>
            </AudienceText>
        </AudienceButton>
    </Selector>
);

export default AuthAudienceSelector;
